export default (editor, opts = {}) => {
  if (opts.disableThumbBlock) return;

  const bm = editor.BlockManager;
  const blockOptions = opts.block || {};
  const label = blockOptions.label || opts.labels?.blockLabel || opts.labels?.section || '';
  const category = blockOptions.category || opts.labels?.blockCategory || '';
  const media = blockOptions.media
    || '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">'
      + '<rect width="24" height="16" y="4" rx="2" fill="#1f2937"/>'
      + '<path d="M6 15l3-4 3 3 2-3 4 4" stroke="#22d3ee" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>';

  const attributes = {
    ...(blockOptions.attributes || {}),
  };

  if (!attributes.src) {
    const placeholderText = blockOptions.placeholderText || label;
    const template = blockOptions.placeholderSrcTemplate;
    const placeholderSrc = blockOptions.placeholderSrc
      || (template && template.includes('{text}')
        ? template.replace('{text}', encodeURIComponent(placeholderText || ''))
        : `https://placehold.co/640x360/111/fff?text=${encodeURIComponent(placeholderText || '')}`);
    if (placeholderSrc) {
      attributes.src = placeholderSrc;
    }
  }

  bm.add('thumbai-image', {
    label,
    category,
    media,
    content: {
      type: 'image',
      attributes,
    },
  });
};
